export function setSelectedIndexForToday(todayNumber) {
  const selectTag = document.querySelector(`select#day`)
  selectTag.selectedIndex = todayNumber - 1
}

export function setSelectedIndexForYear(yearNumber) {
  const selectTag = document.querySelector(`select#year`)
  selectTag.selectedIndex = yearNumber
  selectTag.value = yearNumber
}

export function resetOptionSelectDayFor(month, year) {
  const selectTag = document.querySelector(`select#day`)
  const numberOfDays = new Date(year, month, 0).getDate()
  // จำ "ค่า" วันที่เลือกไว้ ไม่ใช่ตำแหน่ง — ฟอร์มสมัครมี placeholder "วัน" อยู่ index 0
  // ถ้าจำตำแหน่งแล้วสร้างรายการใหม่ที่ไม่มี placeholder วันจะเลื่อนไป +1 เงียบ ๆ
  // (เลือก 8 → เปลี่ยนเดือน → กลายเป็น 9 → ลัคนาผิดทั้งดวง)
  const selectedDay = parseInt(selectTag.value, 10) || 0
  const newOptions = [...Array(numberOfDays).keys()]
    .map((n) => `<option value="${n + 1}">${n + 1}</option>`)
    .join("")
  selectTag.innerHTML = newOptions

  if (selectedDay > 0) {
    // เดือนใหม่มีวันน้อยกว่าวันที่เคยเลือก (เช่น 31 → ก.พ.) — หนีบเป็นวันสุดท้ายของเดือน
    selectTag.value = String(Math.min(selectedDay, numberOfDays))
  }
}

export function resetYearList(era) {
  const selectYearBox = document.getElementById("year")
  selectYearBox.innerHTML = [...Array(80).keys()]
    .map((n) => {
      let value = new Date().getFullYear() - n
      let content = value
      if (era == "buddhist") {
        content += 543
      }
      return `<option value="${value}">${content}</option>`
    })
    .join("")
}

export function setupToggleUnknownBirthTime() {
  const unknownBirthTimeCheckbox= document.getElementById("unknown_birth_time")
  const selectTagHour = document.querySelector(`select#hour`)
  const selectTagMinute = document.querySelector(`select#minute`)
  const editSubscription = document.getElementById("edit-subscription")

  if (unknownBirthTimeCheckbox != null) {
    unknownBirthTimeCheckbox.addEventListener('change', function (event) {
      if (event.currentTarget.checked) {
        disableHourAndMinuteField(selectTagHour, selectTagMinute)

        // Not show the modal when admin edit subscription
        if (editSubscription == null) {
          showUnknownBirthTimeModal(unknownBirthTimeCheckbox, selectTagHour, selectTagMinute)
          hideBackdropWhenPressEsc()
        }
      } else {
        enableHourAndMinuteField(selectTagHour, selectTagMinute)
      }
    })
  }
}

function disableHourAndMinuteField(selectTagHour, selectTagMinute) {
  selectTagHour.value = ""
  selectTagMinute.value = ""
  selectTagHour.disabled = true
  selectTagMinute.disabled = true
}

function enableHourAndMinuteField(selectTagHour, selectTagMinute) {
  selectTagHour.disabled = false
  selectTagMinute.disabled = false
}

function showUnknownBirthTimeModal(checkbox, selectTagHour, selectTagMinute) {
  const unknownBirthTimeModal = document.getElementById("unknown-birth-time-modal")
  const backdrop = document.querySelector(".backdrop")

  unknownBirthTimeModal.showModal()
  backdrop.classList.add("show")

  const closeModal = () => {
    unknownBirthTimeModal.close()
    backdrop.classList.remove("show")
  }

  unknownBirthTimeModal.querySelector("[data-confirm-unknown]").addEventListener("click", closeModal)

  // ทางกลับสำหรับคนติ๊กพลาด: ยกเลิกติ๊ก เปิดช่องเวลา แล้วพาไปกรอกต่อเลย
  unknownBirthTimeModal.querySelector("[data-fill-time]").addEventListener("click", () => {
    checkbox.checked = false
    enableHourAndMinuteField(selectTagHour, selectTagMinute)
    closeModal()
    selectTagHour.focus()
  })
}

function hideBackdropWhenPressEsc() {
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      const backdrop = document.querySelector(".backdrop")
      backdrop.classList.remove("show")
    }
  })
}
